import { React, useState, useEffect } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import Button from "@mui/material/Button";
import DataTable from "examples/Tables/DataTable";
import { Stack, CircularProgress, Box } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "../campus/Campus.css";
import Select from "react-select";
import nodata from "assets/images/nodata.png";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = sessionStorage.getItem("token");

const WaitingList = () => {
  const [selectedCampaign, setSelectedCampaign] = useState("");
  const [campaigns, setCampaigns] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [departments, setDepartments] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [selectedProgram, setSelectedProgram] = useState("");
  const [quotas, setQuotas] = useState([]);
  const [selectedQuota, setSelectedQuota] = useState("");
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [templates, setTemplates] = useState([]);
  const [selectedMeritListType, setSelectedMeritListType] = useState("");
  const [meritListTypes, setMeritListTypes] = useState([]);
  const [waitingListApplications, setWaitingListApplications] = useState([]);
  const [loading, setLoading] = useState(false);

  const getAllCampaigns = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    await fetch(BASE_URL + `/campaign/get_campaigns`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setCampaigns(data.campaigns);
      })
      .catch((error) => console.log(error));
  };

  const getDepartments = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    await fetch(BASE_URL + `/department/get_departments`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setDepartments(data.departments);
      })
      .catch((error) => console.log(error));
  };

  const getDegreesByDepartments = async (department_id) => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    await fetch(
      BASE_URL +
      `/degree/get_grouped_degrees_by_department/${department_id}?campaign_id=${selectedCampaign}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        setPrograms(data.grouped_degrees);
      })
      .catch((error) => console.log(error));
  };

  const getQuotas = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    await fetch(BASE_URL + `/quota/get_quotas`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setQuotas(data.quotas);
      })
      .catch((error) => console.log(error));
  };

  const getTemplates = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    await fetch(
      BASE_URL + `/application/get_merit_list_templates`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        setTemplates(data.templates);
      })
      .catch((error) => console.log(error));
  };

  const handleDepartementChange = (event) => {
    setSelectedDepartment(event.target.value);
    getDegreesByDepartments(event.target.value);
  };

  const handleProgramChange = (event) => {
    setSelectedProgram(event.target.value);
  };

  const handleGetWaitingListApplicants = async () => {
    setLoading(true);
    let data = {
      campaign_id: selectedCampaign,
      department_id: selectedDepartment,
      program_ids: selectedProgram,
      quota_id: selectedQuota,
      template_id: selectedTemplate,
      program_criteria_id: selectedMeritListType,
    };
    console.log(data);
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    };
    await fetch(
      BASE_URL + `/application/generate_waiting_list`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        setWaitingListApplications(data.merit_list || []);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        toast.error("Error fetching waiting list applicants");
      });
  };

  // CSV Export function
  const exportToCSV = () => {
    if (waitingListApplications.length === 0) {
      toast.warning("No data to export");
      return;
    }

    const csvHeaders = [
      "Sr.No",
      "Form No",
      "Name",
      "CNIC",
      "Phone",
      "Father Name",
      "Father Phone",
      "Emergency Phone",
      "Test_name",
      "Total Test Marks",
      "obtain Marks",
      "Aggregate",
    ];

    const csvData = waitingListApplications.map((applicant, index) => [
      index + 1,
      applicant.application_form_id,
      applicant.name,
      applicant.cnic,
      applicant.applicant_phone || "",
      applicant.father_name,
      applicant.father_phone || "",
      applicant.emergency_contact_no || "",
      applicant.selected_test_name || "",
      applicant.selected_test_total_marks || "",
      applicant.selected_test_obtain_marks || "",
      Number(applicant.aggregate || applicant.aggregrate).toFixed(2),
    ]);

    // Convert to CSV string
    const csvContent = [
      csvHeaders.join(","),
      ...csvData.map(row =>
        row.map(field =>
          typeof field === 'string' && field.includes(',')
            ? `"${field}"`
            : field
        ).join(",")
      )
    ].join("\n");

    // Create and download file
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", `waiting_list_${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    toast.success("CSV file downloaded successfully");
  };

  const columns = [
    { Header: "Sr.No", accessor: "serial", align: "center" },
    { Header: "Form No", accessor: "form_no", align: "center" },
    { Header: "Name", accessor: "name", align: "left" },
    { Header: "CNIC", accessor: "cnic", align: "center" },
    { Header: "Phone", accessor: "phone", align: "center" },
    { Header: "Father Name", accessor: "father_name", align: "left" },
    { Header: "Father Phone", accessor: "father_phone", align: "center" },
    { Header: "Emergency Phone", accessor: "emergency_phone", align: "center" },
    { Header: "Test_Name", accessor: "Test_Name", align: "left" },
    { Header: "Total Test Marks", accessor: "total_marks", align: "center" },
    { Header: "Obtained Marks", accessor: "obtain_marks", align: "center" },
    { Header: "Aggregate", accessor: "aggregate", align: "center" },
  ];

  const rows =
    waitingListApplications.length > 0
      ? waitingListApplications.map((applicant, index) => {
        return {
          serial: index + 1,
          form_no: applicant.application_form_id,
          name: applicant.name,
          cnic: applicant.cnic,
          phone: applicant.applicant_phone || "-",
          father_name: applicant.father_name,
          father_phone: applicant.father_phone || "-",
          emergency_phone: applicant.emergency_contact_no || "-",
          Test_Name: applicant.selected_test_name,
          total_marks: applicant.selected_test_total_marks || "-",
          obtain_marks: applicant.selected_test_obtain_marks || "-",
          aggregate: Number(applicant.aggregate || applicant.aggregrate).toFixed(2),
        };
      })
      : [];

  useEffect(() => {
    getAllCampaigns();
    getDepartments();
    getQuotas();
    getTemplates();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor="campaign">Campaign</label>
                  <Select
                    id="campaign"
                    options={campaigns}
                    getOptionLabel={(e) => e.name}
                    getOptionValue={(e) => e.id}
                    value={campaigns.find((c) => c.id === selectedCampaign)}
                    onChange={(option) => setSelectedCampaign(option?.id)}
                    isSearchable
                    placeholder="Select Campaign"
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor="department">Department</label>
                  <Select
                    id="department"
                    options={departments}
                    getOptionLabel={(dept) => dept.name}
                    getOptionValue={(dept) => dept.id}
                    value={departments.find(
                      (d) => d.id === selectedDepartment
                    )}
                    onChange={(option) =>
                      handleDepartementChange({
                        target: { value: option?.id },
                      })
                    }
                    isSearchable
                    placeholder="Select Department"
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor="program">Program</label>
                  <Select
                    id="program"
                    options={programs}
                    getOptionLabel={(e) => e.name}
                    getOptionValue={(e) => e.id}
                    value={programs.find((p) => p.id === selectedProgram)}
                    onChange={(option) => {
                      const programId = option?.id || null;
                      console.log("Selected Program ID:", programId);
                      setSelectedProgram(programId);
                      //find program by id and get sessions
                      const selectedProgramObj = programs.find(
                        (p) => p.id === programId
                      );
                      const sessions = selectedProgramObj?.sessions || [];
                      console.log("Sessions for selected program:", sessions);
                      setMeritListTypes(sessions);
                      // Reset merit list type when program changes
                      setSelectedMeritListType("");
                    }}
                    isSearchable
                    placeholder="Select Program"
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor="quota">Quota</label>
                  <Select
                    id="quota"
                    options={quotas}
                    getOptionLabel={(quota) => quota.name}
                    getOptionValue={(quota) => quota.id}
                    value={quotas.find((q) => q.id === selectedQuota)}
                    onChange={(option) => setSelectedQuota(option?.id)}
                    isSearchable
                    placeholder="Select Quota"
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor="template">Template</label>
                  <Select
                    id="template"
                    options={templates}
                    getOptionLabel={(template) => template.name}
                    getOptionValue={(template) => template.id}
                    value={templates.find((t) => t.id === selectedTemplate)}
                    onChange={(option) => setSelectedTemplate(option?.id)}
                    isSearchable
                    placeholder="Select Template"
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor="meritListType">Merit List Type</label>
                  <Select
                    id="meritListType"
                    options={meritListTypes}
                    getOptionLabel={(type) => type.session}
                    getOptionValue={(type) => type.program_id}
                    value={meritListTypes.find((t) => t.program_id === selectedMeritListType)}
                    onChange={(option) => setSelectedMeritListType(option?.program_id)}
                    isSearchable
                    placeholder="Select Merit List Type"
                    className="react-select-container"
                    classNamePrefix="react-select"
                    isDisabled={!selectedProgram || meritListTypes.length === 0}
                  />
                </div>
              </div>
              <div className="col-md-3 mt-3 d-flex justify-content-end gap-2">
                <Button
                  variant="outlined"
                  onClick={handleGetWaitingListApplicants}
                  className="add-full-button"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <CircularProgress size={20} sx={{ mr: 1 }} />
                      Loading...
                    </>
                  ) : (
                    "Get Waiting List Applicants"
                  )}
                </Button>
                {waitingListApplications.length > 0 && (
                  <Button
                    variant="contained"
                    onClick={exportToCSV}
                    sx={{
                      backgroundColor: '#28a745',
                      '&:hover': { backgroundColor: '#218838' }
                    }}
                  >
                    Export CSV
                  </Button>
                )}
              </div>
            </div>
            <Card className="mt-5 card1">
              <MDBox pt={3}>
                {loading ? (
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    minHeight="200px"
                    flexDirection="column"
                  >
                    <CircularProgress size={50} />
                    <Box mt={2} fontSize="16px" color="text.secondary">
                      Loading waiting list applicants...
                    </Box>
                  </Box>
                ) : waitingListApplications && waitingListApplications.length > 0 ? (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                ) : (
                  <div style={{ textAlign: "center" }}>
                    <img
                      src={nodata}
                      style={{
                        display: "block",
                        margin: "auto",
                        width: "20%",
                        height: "20%",
                      }}
                    />
                  </div>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
};

export default WaitingList;